import req from './request.js'

export function userRInfo(data) {
  return req('get', '/api/user/index', data)
}

export function favoriteList(data) {
  return req('get', '/api/video/favorite', data)
}

export function tFavorite(data) {
  return req('post', '/api/user/toggleFavorite', data)
}

export function videoHstory(data) {
  return req('get', '/api/video/videolog', data)
}

export function logout(data) {
  return req('get', '/api/user/logout', data)
}

export function uploadFile(data) {
  return req('post', '/api/user/upload', data)
}

export function editProfile(data) {
  return req('post', '/api/user/editProfile', data)
}

export function changePwd(data = {}) {
  return req('post', '/api/user/changePwd', {
    oldpassword: data.oldpassword || data.oldPassword || '',
    password: data.password || '',
    repassword: data.repassword || data.confirmPassword || ''
  })
}
